export default "__VITE_ASSET__D$YKT49w__"